import { get } from '@/services/http';
import { ChurnedPredictedMerchant, ChurnedPredictedResponse } from '@/types/churn';

export class ChurnChurnedPredictedModel {
    public merchants: ChurnedPredictedMerchant[] = [];
    public total: number = 0;
    public limit: number = 50;
    public offset: number = 0;

    public async fetch(params: {
        date?: string;
        limit: number;
        offset: number;
    }): Promise<void> {
        const query: any = {
            limit: params.limit,
            offset: params.offset,
        };
        if (params.date) { query.date = params.date; }

        const res: any = await get('/churn/churned-predicted', query);
        this.mapData(res.data);
    }

    public mapData(data: ChurnedPredictedResponse): void {
        this.merchants = data.merchants;
        this.total = data.total;
        this.limit = data.limit;
        this.offset = data.offset;
    }
}
